import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArchiveRegular from './archive-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArchiveRegular {...validProps} />;
}
SvgComponent.iconName = 'archiveRegular';

export const ArchiveRegularIcon = svgIconWrapper(SvgComponent);
